module.exports = __webpack_public_path__ + "img/magalu.ca7af29b.png";